import { SurveyDTO, ListSurveyResult } from '../surveys.types';

export const surveys: ListSurveyResult = {
  surveys: [
    {
      surveyId: '66061d37f45d7f5250d7e3df',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Test Atlas',
      description: 'Test Atlas',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Test Atlas',
          shortDescription: 'Test Atlas',
          longDescription: 'Test Atlas',
          imageUrl: null,
        },
      ],
      createdDateTime: '2024-03-29T01:45:27',
      modifiedDateTime: '2024-03-29T01:45:27',
    },
    {
      surveyId: '65f1b1fbb45f890599afeaf8',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'survey-kav-regression',
      description: 'survey-kav-regression',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'survey-kav-regression',
          shortDescription: 'survey-kav-regression',
          longDescription: 'survey-kav-regression',
          imageUrl: null,
        },
      ],
      createdDateTime: '2024-03-13T14:02:35',
      modifiedDateTime: '2024-03-13T14:02:35',
    },
    {
      surveyId: '65f1605f66501c0bfc95cdb3',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'survey-kav-13-3',
      description: 'survey-kav-13-3',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'FR',
          title: 'survey-kav-13-3',
          shortDescription: 'survey-kav-13-3',
          longDescription: 'survey-kav-13-3',
          imageUrl: null,
        },
      ],
      createdDateTime: '2024-03-13T08:14:23',
      modifiedDateTime: '2024-03-13T08:28:13',
    },
    {
      surveyId: '65f14b79deba8f7aa792d3b4',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'survey-13-3-single-questions',
      description: 'survey-13-3-single-questions',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'survey-13-3-single-questions',
          shortDescription: 'survey-13-3-single-questions',
          longDescription: 'survey-13-3-single-questions',
          imageUrl: null,
        },
      ],
      createdDateTime: '2024-03-13T06:45:13',
      modifiedDateTime: '2024-03-13T06:45:13',
    },
    {
      surveyId: '65efd061deba8f7aa792d3b2',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'survey-kav-testing-10-limit',
      description: 'survey-kav-testing-10-limit',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'survey-kav-testing-10-limit',
          shortDescription: 'survey-kav-testing-10-limit',
          longDescription: 'survey-kav-testing-10-limit',
          imageUrl: null,
        },
      ],
      createdDateTime: '2024-03-12T03:47:45',
      modifiedDateTime: '2024-03-12T03:47:45',
    },
    {
      surveyId: '65eb097e267aa30348f804f4',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'survey-kav',
      description: 'survey-kav',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'survey-kav',
          shortDescription: 'survey-kav',
          longDescription: 'survey-kav...............',
          imageUrl: null,
        },
      ],
      createdDateTime: '2024-03-08T12:50:06',
      modifiedDateTime: '2024-03-08T12:50:06',
    },
    {
      surveyId: '655dc9b9fa3c5f4dcb7ed9cc',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'S_test survey',
      description: 'S_test survey',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'S_test survey',
          shortDescription: 'S_test survey',
          longDescription: 'S_test survey',
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-11-22T09:28:25',
      modifiedDateTime: '2023-11-22T10:20:33',
    },
    {
      surveyId: '655d8833fa3c5f4dcb7ed9c5',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Shona Test Survey2',
      description: 'Surveys 001Surveys 001Surveys 001Surveys 001',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'survey Title Shona',
          shortDescription: 'Short Description',
          longDescription: 'Long DescriptionLong Description',
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-11-22T04:48:51',
      modifiedDateTime: '2023-11-22T09:30:31',
    },
    {
      surveyId: '655d738dfa3c5f4dcb7ed9c4',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Shona Test Survey',
      description: 'Shona Test Survey',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Shona Test Survey',
          shortDescription:
            'Shona Test SurveyShona Test SurveyShona Test SurveyShona Test Survey',
          longDescription:
            'Shona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test SurveyShona Test Survey',
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-11-22T03:20:45',
      modifiedDateTime: '2023-11-22T03:20:45',
    },
    {
      surveyId: '65549cd9468995044ce78dfa',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '941f60f6-15ec-4ec4-9fe5-c07352ce8125',
      locationId: null,
      name: 'test bug 7',
      description: 'test bug 7',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'test bug 7',
          shortDescription: 'test bug 7',
          longDescription: 'test bug 7',
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-11-15T10:26:33',
      modifiedDateTime: '2023-11-15T10:26:41',
    },
    {
      surveyId: '652526ead3d7dc536aca5e81',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Surveys 001',
      description: 'Surveys 001Surveys 001Surveys 001Surveys 001',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Surveys 001',
          shortDescription:
            'Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001',
          longDescription:
            'Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001Surveys 001',
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-10-10T10:26:50',
      modifiedDateTime: '2023-10-10T10:26:50',
    },
    {
      surveyId: '650abc58d3d7dc536aca5e7e',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'WOV2 regression SURVEY',
      description:
        'SURVEY for Weekly Release - Manual Smoke Test Feedback on Web Ordering v2',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'SURVEY WOV2 Reg',
          shortDescription: 'SURVEY for Weekly Release',
          longDescription:
            'SAMPLE TEST SURVEY for Weekly Release - Manual Smoke Test Feedback on Web Ordering v2',
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-09-20T09:33:12',
      modifiedDateTime: '2023-09-20T09:33:36',
    },
    {
      surveyId: '64bb21046181087e0630048d',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
      locationId: null,
      name: 'Test Survey SB2',
      description: 'Test Survey to Test Springboot 2 Upgrade',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Test Survey for SB2 Upgrade',
          shortDescription: 'Test Survey',
          longDescription: 'Test Survey for SB2 Upgrade',
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-07-22T00:21:24',
      modifiedDateTime: '2023-07-22T00:21:24',
    },
    {
      surveyId: '6450bfafd3d7dc06e23e7e3c',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'SURVEY Reg 2023-05-02',
      description: 'SURVEY 01',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'SURVEY 01',
          shortDescription: 'short SURVEY',
          longDescription: 'Long SURVEY',
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-05-02T07:45:51',
      modifiedDateTime: '2023-05-02T07:45:51',
    },
    {
      surveyId: '644a1734d3d7dc58951ffec2',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Activity Distributor Survey',
      description: 'Activity Distributor Survey',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Activity Distributor Survey',
          shortDescription: 'Activity Distributor Survey',
          longDescription: 'v',
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-04-27T06:33:24',
      modifiedDateTime: '2023-04-27T08:10:26',
    },
    {
      surveyId: '63ff4243d3d7dc49fd9af2f1',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: "Provide feedback Sanity (Don't Edit) 1",
      description: "Provide feedback Sanity (Don't Edit) 1",
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: "Provide feedback Sanity (Don't Edit) 1",
          shortDescription: "Provide feedback Sanity (Don't Edit) 1",
          longDescription: "Provide feedback Sanity (Don't Edit) 1",
          imageUrl: null,
        },
      ],
      createdDateTime: '2023-03-01T12:17:07',
      modifiedDateTime: '2024-03-08T05:29:07',
    },
    {
      surveyId: '626235efd3d7dc329ef1e777',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Latest Survey 22/04/2022',
      description: 'Latest Survey 22/04/2022',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Latest Survey 22/04/2022',
          shortDescription: 'Latest Survey 22/04/2022',
          longDescription: 'Latest Survey 22/04/2022',
          imageUrl: null,
        },
      ],
      createdDateTime: '2022-04-22T04:58:23',
      modifiedDateTime: '2022-04-22T04:58:23',
    },
    {
      surveyId: '6245a3f9d3d7dc329ef1e744',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'engineering@incentivio.com',
      description: 'SMS Survey',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'SMS Survey',
          shortDescription: 'SMS Survey',
          longDescription: 'SMS Survey',
          imageUrl: null,
        },
      ],
      createdDateTime: '2022-03-31T12:52:09',
      modifiedDateTime: '2022-05-13T09:07:16',
    },
    {
      surveyId: '6234574ad3d7dc345ce359c4',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Test Survey H',
      description: 'Test Survey for Sanity test',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Test Survey Hesh',
          shortDescription: 'Test Survey for Sanity testing in DEV',
          longDescription:
            'Test Survey with questions for Sanity testing in DEV env.',
          imageUrl: null,
        },
      ],
      createdDateTime: '2022-03-18T09:56:26',
      modifiedDateTime: '2022-03-18T09:56:26',
    },
    {
      surveyId: '621bb310d3d7dc345ce35961',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'User Domain Survey',
      description: 'User Domain Survey',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'User Domain Survey',
          shortDescription: 'User Domain Survey',
          longDescription: 'User Domain Survey',
          imageUrl: null,
        },
      ],
      createdDateTime: '2022-02-27T17:21:20',
      modifiedDateTime: '2022-02-27T17:21:20',
    },
    {
      surveyId: '61f7c30bd3d7dc47c712eaba',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Test Survey 1234',
      description: 'Test Survey 1234',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Test Survey 1234',
          shortDescription: 'Test Survey',
          longDescription: 'Test Survey',
          imageUrl: null,
        },
      ],
      createdDateTime: '2022-01-31T11:07:55',
      modifiedDateTime: '2022-01-31T11:07:55',
    },
    {
      surveyId: '61caafd4d3d7dc0c02a39039',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Test Survey cutover',
      description: 'Test Survey cutover',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Test Survey cutover',
          shortDescription: 'Test Survey cutover',
          longDescription: 'Test Survey cutover',
          imageUrl: null,
        },
      ],
      createdDateTime: '2021-12-28T06:33:56',
      modifiedDateTime: '2021-12-28T06:33:56',
    },
    {
      surveyId: '60c2e7d35d3ee44d0084a66d',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Test SURVEY RUSH',
      description: 'this is a test survey',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Test survey message RUSH',
          shortDescription: 'this is  the short desc for survey',
          longDescription: 'long desc for survey',
          imageUrl: null,
        },
      ],
      createdDateTime: '2021-06-11T04:34:27',
      modifiedDateTime: '2021-06-11T04:34:27',
    },
    {
      surveyId: '6062bf215d3ee47406184a5d',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: 'Test Survey BootApp',
      description: 'Test Survey BootApp',
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'Test Survey BootApp',
          shortDescription: 'Test Survey BootApp',
          longDescription: 'Test Survey BootApp',
          imageUrl: null,
        },
      ],
      createdDateTime: '2021-03-30T06:03:13',
      modifiedDateTime: '2021-12-28T06:34:47',
    },
    {
      surveyId: '5ec6825330e0f222113cfc63',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      locationId: null,
      name: "Provide feedback Sanity (Don't Edit)",
      description: "Provide feedback Sanity (Don't Edit)",
      imageUrl: null,
      surveyDisplayInfos: [
        {
          languageCode: 'FR',
          title: 'Fournir une r?ponse',
          shortDescription: 'Fournir une r?ponse',
          longDescription: 'Fournir une r?ponse',
          imageUrl: null,
        },
        {
          languageCode: 'EN',
          title: 'Provide feedback',
          shortDescription: 'Please leave your feedback using the form below',
          longDescription: 'Provide feedback',
          imageUrl: null,
        },
      ],
      createdDateTime: '2020-05-21T13:29:55',
      modifiedDateTime: '2023-08-15T08:10:31',
    },
  ],
  paging: {
    total: 25,
    count: 1000,
    totalPages: 1,
    currentPage: 0,
  },
};

/**
 * A single survey with its full question records, as returned by GET
 * /surveys/{surveyId}. Used by the get-survey mock and edit-flow tests.
 */
export const surveyDetail: SurveyDTO = {
  surveyId: '66061d37f45d7f5250d7e3df',
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
  locationId: null,
  name: 'Test Atlas',
  description: 'How was your visit?',
  imageUrl: null,
  surveyDisplayInfos: [
    {
      languageCode: 'EN',
      title: 'Test Atlas',
      shortDescription: 'How was your visit?',
      longDescription: 'How was your visit?',
      imageUrl: null,
    },
  ],
  questions: [
    {
      questionId: 'q-single-1',
      type: 'SINGLE_CHOICE',
      questionTitle: 'How did you hear about us?',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      isMandatory: true,
      questionDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'How did you hear about us?',
          questionDescription: '',
        },
      ],
      choices: [
        {
          choiceId: 'c-1',
          choiceTitle: 'Social media',
          positionIndex: 0,
          choiceDisplayInfos: [{ languageCode: 'EN', title: 'Social media' }],
        },
        {
          choiceId: 'c-2',
          choiceTitle: 'A friend',
          positionIndex: 1,
          choiceDisplayInfos: [{ languageCode: 'EN', title: 'A friend' }],
        },
      ],
      createdDateTime: '2024-03-29T01:45:27',
      modifiedDateTime: '2024-03-29T01:45:27',
    },
    {
      questionId: 'q-rating-1',
      type: 'RATING',
      questionTitle: 'How would you rate your visit?',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      isMandatory: false,
      questionDisplayInfos: [
        {
          languageCode: 'EN',
          title: 'How would you rate your visit?',
          questionDescription: '',
        },
      ],
      choices: Array.from({ length: 5 }, (_, index) => ({
        choiceId: `r-${index + 1}`,
        choiceTitle: String(index + 1),
        positionIndex: index,
        choiceDisplayInfos: [{ languageCode: 'EN', title: String(index + 1) }],
      })),
      createdDateTime: '2024-03-29T01:45:27',
      modifiedDateTime: '2024-03-29T01:45:27',
    },
  ],
  createdDateTime: '2024-03-29T01:45:27',
  modifiedDateTime: '2024-03-29T01:45:27',
};
